import { render, staticRenderFns } from "./CitationLinks.vue?vue&type=template&id=11f6d5e8"
import script from "./CitationLinks.vue?vue&type=script&lang=js"
export * from "./CitationLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports